import { 
  REQUEST_ORDER_STATUS, 
  RECEIVE_ORDER_STATUS,
  FAIL_ORDER_STATUS, 
} from "../actions/status";

export default function status(state = {
  loading: false,
  loaded: false,
  detail: {},
  fetchError: false
}, action) {
  switch (action.type) {
    case REQUEST_ORDER_STATUS:
      return {
        ...state,
        loading: true,
      };
    case RECEIVE_ORDER_STATUS:
      return {
        ...state,
        fetchError: false,
        loading: false,
        loaded: true,
        detail: action.payload.detail
      };
    case FAIL_ORDER_STATUS:
      return {
        ...state,
        loading: false,
        fetchError: true
      };
    default:
      return state;
  }
}